import { forEach } from '../helpers/pseudoPolyfills';

export function priceWrapper() {
  const textsWithPriceList =  document.querySelectorAll('.wrapPrice');
  forEach(textsWithPriceList, (index, elem) => {
    let priceText = "";
    const wrapClass = elem.dataset.wrapClass;

    if(elem.classList.contains('wrapPrice--wrapped')) {
      return;
    }

    elem.classList.add('wrapPrice--wrapped');

    if(elem.dataset.wrapOnlyInteger === 'true' && elem.innerText.match(/\d(.*)\d/)) {
      priceText = elem.innerText.match(/\d(.*)\d/)[0];    // match only integer part of fractional number (eg 28,21 will match only 28)
      const integerPart = priceText.split(',')[0];
      const fractionPart = ',' + priceText.split(',')[1];
      elem.innerHTML = elem.innerText
      .replace(integerPart, `<b class="${wrapClass}">${integerPart}</b>`)
      .replace(fractionPart, `<b class="${wrapClass}-smoll">${fractionPart}</b>`);
      return;
    } else {
      if (elem.innerText.match(/\d(.*)\//)) {
        priceText = elem.innerText.match(/\d(.*)\//)[0];    // match everything between first digit and '/' on the end
        elem.innerHTML = elem.innerText.replace(priceText, `<b class="${wrapClass}">${priceText}</b>`);
      }
    }
  });
}
